import React, { useEffect } from 'react'
import scheduleJSON from './data/data'
import { useParams as routeParams } from 'react-router-dom'
import { sentenceCase, capitalCase } from 'change-case'
import './TripDetails.scss'
import Button from '@material-ui/core/Button'



function Attractions(props) {
  const { attractions } = props.trip
  return (
    <table className='attractions-table'>
      <tbody>
        <AttractionTableRows attractions={attractions} />
      </tbody>
    </table>
  )
}

function AttractionTableRows(props) {
  const { attractions } = props
  return attractions.map((attraction, idx) => {
    return <tr key={idx} onClick={() => document.getElementById(`attraction-${idx}`).scrollIntoView()} className="attraction"><td>{capitalCase(`${attraction.name}`)}</td></tr>
  })
}

function AttractionImages(props) {
  const { images } = props
  console.log(images)
  return images.map((image, idx) => {
    return (
      <img key={idx} src={`${process.env.PUBLIC_URL}/assets/images/${image}`} alt=""/>
    )
  })
}

function AttractionsDetails(props) {
  const { attractions } = props.trip
  return attractions.map((attraction, idx) => {
    return (
      <div id={`attraction-${idx}`} key={idx} className="attraction-details">
        <h4>{capitalCase(attraction.name)}</h4>
        <span className="summary"><p>{sentenceCase(`${attraction.summary}`)}</p></span>
        <p className='attraction-images'>
          <AttractionImages images={attraction.pics} />
        </p>
        <p className="more-wiki">
          <Button variant='contained' disableElevation size='large'>
            <a href={`${attraction.wiki}`} target='_blank'>Learn More</a>
          </Button>
        </p>
        <p className="more-pics">
          <Button variant='contained' disableElevation size='large'>
            <a href={`${attraction.map}`} target='_blank'>See On Maps</a>
          </Button>
        </p>
        <p className="more-pics">
          <Button variant='contained' disableElevation size='large'>
            <a href={`${attraction.morePics}`} target='_blank'>See Pics</a>
          </Button>
        </p>
        <p className="more-pics">
          <Button variant='contained' disableElevation size='large'>
            <a href={`${attraction.moreVids}`} target='_blank'>See Videos</a>
          </Button>
        </p>
      </div>
    )
  })
}

function HotelDetails(props) {
  const { hotel } = props.trip
  return (
    <div className="hotel-details">
      <p>{`${hotel.name}`}</p>
      <p>{`${hotel.startDate} - ${hotel.endDate}`}</p>
      <p>
        <Button variant='contained' disableElevation size='large'>
          <a href={`${hotel.map}`} target='_blank'>See On Maps</a>
        </Button>
      </p>
    </div>
  )
}

function TripDetails() {
  let { idx } = routeParams()
  let trip = scheduleJSON.schedule[idx]

  useEffect(() => {
    window.scrollTo(0, 0)
  })

  return (
    <div id="trip-details">
      <h1>{`Day ${trip.overview.no}`}</h1>
      <h2 className="sub-title">Today's Attraction</h2>
      <Attractions trip={trip} />

      <h2 className="sub-title">Hotel Details</h2>
      <HotelDetails trip={trip} />

      <h2 className="sub-title">More Details</h2>
      <AttractionsDetails trip={trip} />

    </div>
  )
}

export default TripDetails
